// Utility functions for accessing CSS theme variables

/**
 * Get a CSS variable value from the root element
 * @param {string} variableName - The CSS variable name (with or without --)
 * @returns {string} The CSS variable value
 */
export const getCSSVariable = (variableName) => {
	const name = variableName.startsWith("--") ? variableName : `--${variableName}`;
	return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
};

/**
 * Get the primary color from CSS variables
 * @returns {string} The primary color
 */
export const getPrimaryColor = () => getCSSVariable("color-primary");

/**
 * Get the primary color with alpha transparency
 * @param {number} opacity - Opacity value (5, 8, 10, 12, 15, 20, 25, 30, 40)
 * @returns {string} The primary color with alpha
 */
export const getPrimaryAlpha = (opacity = 10) => {
	return getCSSVariable(`color-primary-alpha-${opacity}`);
};

/**
 * Get primary color variants
 * @returns {object} Object with primary color variants
 */
export const getPrimaryColors = () => ({
	primary: getCSSVariable("color-primary"),
	primaryDark: getCSSVariable("color-primary-dark"),
	primaryLight: getCSSVariable("color-primary-light"),
	primaryHover: getCSSVariable("color-primary-hover"),
	primaryActive: getCSSVariable("color-primary-active"),
});

